import { Box, Modal } from "@mui/material";
import React from "react";

interface DefaultModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;

  width?: number | string;
}

const DefaultModal: React.FC<DefaultModalProps> = ({
  open,
  onClose,
  title,
  children,
  width = 400
}) => {
  return (
    <>
      <Modal open={open} onClose={onClose} aria-labelledby="default-modal">
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "var(--surface)",
            border: "1px solid var(--border-strong)",
            color: "var(--text)",
            p: 3,
            borderRadius: 2,
            boxShadow: 24,
            width: width,
            maxHeight: "90vh",
            overflowY: "auto"
          }}
        >
          <h2>{title}</h2>
          {children}
        </Box>
      </Modal>
    </>
  );
};

export default DefaultModal;
